export default __webpack_public_path__ + "static/media/my-riza-leaf.6512804e.svg";